import React from 'react'
import { AsyncState, fromJSX, IOWidget, Updater } from 'widgets-for-react'
import { AuthState } from '../../../authentication/auth_widget/authState'
import { isLoggedIn } from '../../../authentication/auth_widget/utils'
import { userType } from '../../../subscription/subscriptionApi'
import { UserSubscriptions } from '../../../subscription/subscriptionState'
import { CurrentPage } from '../../../utils/routes'
import { inject } from '../../../utils/safe-type-casting'
import { fieldReplacer } from '../../../utils/updaters'
import { RootState, rootStateUpdaters } from '../rootState'
import { Pages } from '../routes/routesState'
import { SearchTab } from '../search/searchState'
import { HeaderLayout } from './headerLayout'
import { HeaderState, headerStateUpdaters } from './headerState'

export const headerWidget =
  (
    authState: AuthState,
    userSubscriptionsState: AsyncState<UserSubscriptions>,
    pageKind: CurrentPage<Pages>['kind'],
    searchTab: SearchTab
  ): IOWidget<HeaderState, Updater<RootState>> =>
  (headerState) =>
    inject((setRootState) =>
      fromJSX<Updater<HeaderState>>((setState) => (
        <HeaderLayout
          languageSwitchMode={headerState.languageSwitchMode}
          mobileMenuMode={headerState.mobileMenuMode}
          setMobileMenuMode={(newMode: 'open' | 'closed') =>
            setState(headerStateUpdaters.updateMobileMenuMode(newMode))
          }
          setLanguageSwitchMode={(newMode: 'open' | 'closed') =>
            setState(headerStateUpdaters.updateLanguageMode(newMode))
          }
          searchString={headerState.searchString}
          setSearchString={(newSearchString) =>
            setState(
              fieldReplacer<HeaderState>()('searchString')(newSearchString)
            )
          }
          searchTab={searchTab}
          isLoggedIn={isLoggedIn(authState)}
          pageKind={pageKind}
          userName={
            userSubscriptionsState.kind === 'loaded'
              ? userSubscriptionsState.value.User.Name
              : ''
          }
          userType={userType(userSubscriptionsState)}
          onLanguageChanged={() =>
            setRootState(rootStateUpdaters.languageChanged)
          }
        />
      )).map(rootStateUpdaters.updateHeaderState)
    )
